module.exports = __webpack_public_path__ + "img/OT.bd96962d.png";